export function isPageComponent(blockElement) {
    return (blockElement.tagName === 'AFFINE-DOC-PAGE' ||
        blockElement.tagName === 'AFFINE-EDGELESS-PAGE');
}
//# sourceMappingURL=guard.js.map